import '../set_public_path';
import '@babel/polyfill/noConflict'
import React from 'react'

import {configure} from 'mobx'
import ProfileSettingsController from './controller/ProfileSettingsController'

(function () {
    function appendManualLink($block) {
        if ($block.find('.market-manual-link').length === 0) {
            const $manualLink = $(
                '<a class="market-manual-link" href="https://bodysite.ru/help/1324/instruktsiya-po-nastroyke-plagina-yandeksmarket-pro/" target="_blank">Инструкция по настройке</a>')
            $block.append($manualLink)
        }
    }

    const $headerBlock = $('#s-importexport-header')

    if ($headerBlock.length > 0) {
        appendManualLink($headerBlock)

        $(window).on('hashchange', function () {
            if (window.location.hash.indexOf('#/market') === -1) {
                $headerBlock.find('.market-manual-link').remove()
                $('.js-market-plugin__clone-block').remove()
            } else {
                appendManualLink($headerBlock)
            }
        })
    }
})()

configure({
    isolateGlobalState: true,
})

window.shop_market_plugin_profile_settings_controller = new ProfileSettingsController()